module.exports = __webpack_public_path__ + "static/media/WonderUnitSans-Regular.8eac5dcd.woff";